import { Container, Box, Typography } from '@mui/material';
import './Menu.css';
import React from "react";

function Menu() {
  // TODO
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
        textAlign: "center",
      }}
    >
      <Box>
        <Typography variant="h6" sx={{ mb: 2 }}>
          It's a little empty around here
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          Things are still under construction. The content is coming soon!
        </Typography>
      </Box>
    </Container>
  );
}

export default Menu;
